export class userManagement{
    _id:any;
    userId:any;
    mobileNumber:any;
    mobileNumberStatus:any;
    accountId:any
    accountEmailAddress:any;
    accountStatus:any;
    userType:any;
    ApprovedByPrimaryUser:any;
    firstName:any
    lastName:any
    DOB:any;
    gender:any;
    location:any;
    dateOfRegistration:any;
    sessionStatus:any
    status:any
}